import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotMangaSection from './components/HotMangaSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import ReviewSection from './components/ReviewSection';
import StatsSection from './components/StatsSection';
import FaqSection from './components/FaqSection';
import NewsletterCTASection from './components/NewsletterCTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotMangaSection />
        <CategorySection />
        <LatestSection />
        <ReviewSection />
        <StatsSection />
        <FaqSection />
        <NewsletterCTASection />
      </main>
      <Footer />
    </>
  );
}